export enum ErrorEnum {
  TR_FUNCTIONAL_ERROR = '-1',
  TR_TECHNICAL_ERROR = '-2',

  SECRET_CODE_SYNTAX_ERROR = '1001',
  SECRET_CODE_SEMANTIC_ERROR = '1002',
  SECRET_CODE_ALREADY_ATTACHED = '1003',
  SECRET_CODE_EXPIRED = '1004',

  INVALID_DRAFT_VERSION = '1057'
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/error.constants.ts